import type { ReactNode } from 'react'
import { Menu as BaseMenu } from '@base-ui/react/menu'

import { ChevronRightIcon } from '@gto/icons-react/solid/chevron-right'
import { cn } from '@gto/ui/cn'

import { menuItemVariants } from './item.styles'

type SubmenuTriggerProps = Omit<BaseMenu.SubmenuTrigger.Props, 'children'> & {
  children?: ReactNode
  selected?: boolean
}

/**
 * Item row that opens a `Menu.SubmenuRoot` on hover / focus. A trailing
 * chevron-right is appended automatically; pass children for the leading
 * icon + label, same shape as a regular `Menu.Item`.
 */
export const SubmenuTrigger = ({
  children,
  className,
  selected,
  ...props
}: SubmenuTriggerProps) => {
  return (
    <BaseMenu.SubmenuTrigger
      className={cn(menuItemVariants(), className)}
      data-selected={selected === true ? '' : undefined}
      {...props}
    >
      {children}
      <ChevronRightIcon className="ml-auto" />
    </BaseMenu.SubmenuTrigger>
  )
}
